function setCookie() {
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 4);

  const cookieValue = encodeURIComponent("true") + "; expires=" + expirationDate.toUTCString();
  document.cookie = "Acceptcookies" + "=" + cookieValue + "; path=/";
  console.log('cookie set')
}
function hasCookie(name, value) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + "=")) {
      const cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
      if (cookieValue === value) {
        return true;
      }
    }
  }
  return false;
}
const hasAcceptCookies = hasCookie("Acceptcookies", "true");

const cookiesbutton = document.querySelector('#cookies-pop-up > .button');
cookiesbutton.addEventListener('click',()=>{
  setCookie();
  cookiesbutton.parentNode.style.display = 'none';
  cookiesbutton.parentNode.remove();

});

if (hasAcceptCookies) {
  cookiesbutton.parentNode.style.display = 'none';
  cookiesbutton.parentNode.remove();
}
else{
  cookiesbutton.parentNode.style.display = 'block';
}



